import TermsOfUsePage from '../components/LegalPages/components/TermsOfUsePage';
import { publicMeta } from './public-meta';

export const meta = publicMeta('Terms of Use | Cartwheel');

export default TermsOfUsePage;
